/* global $:false */

import PusherClient from 'src/shared/pusher_client.js'

export default class Bidder {
  static init () {
    if (!this._onLivePage()) { return }
    if (window.gon && !window.gon.logged_in) { return }
    if (!this.findElements()) { return }
    this.readData()
    this.subscribeToUpdates()
    this.updateForm()
    return true
  }

  static findElements () {
    this.el = $('[data-live-bidder]')
    if (!(this.el.length > 0)) { return }
    this.formContainer = this.el.find('.js-live-page-form')
    return true
  }

  static readData () {
    this.placeBidUrl = this.el.data('url')
    this.unlockBiddingUrl = this.el.data('unlock-bidding-url')
    this.formUrl = this.formContainer.data('url')
  }

  static pusherConnection () {
    return PusherClient.connection()
  }

  static subscribeToUpdates () {
    const channel = this.pusherConnection().subscribe('live-interface')
    channel.bind('update', () => this.updateForm())
    channel.bind('bidding', () => this.updateForm())
    channel.bind('reload-bidder-page', () => this.reloadPage())
    channel.bind('bidding_locked', () => this.disableForm())
    channel.bind('bidding_unlocked', () => {
      this.enableForm()
      this.hideError()
    })
  }

  static reloadPage () {
    window.location.reload()
  }

  static updateForm () {
    if (!this._onLivePage()) { return }
    this.formContainer.load(`${this.formUrl} [data-ajax-live-form]`, () => this.bindToForm())
  }

  static bindToForm () {
    this.unlockBidButton = this.el.find('[data-unlock-bidding]')
    this.placeBidButton = this.el.find('[data-place-bid]')
    this.spinnerContainer = this.el.find('[data-bidder-spinner]')
    this.lotId = this.placeBidButton.data('lot-id')

    this.unlockBidButton.bind('click', event => {
      event.preventDefault()
      event.stopPropagation()
      this.unlockForBidding()
    })

    this.placeBidButton.bind('click', event => {
      event.preventDefault()
      event.stopPropagation()
      if (!this.placeBidButton.attr('disabled')) { this.placeBid() }
    })

    if (this.isUnlockCookieSet(this.lotId)) {
      this.unlockBidButton.hide()
    } else {
      this.placeBidButton.hide()
    }
    this.enableForm()
  }

  static unlockForBidding () {
    this.setUnlockCookie(this.lotId)
    this.unlockBidButton.hide()
    this.placeBidButton.show()
    const data = {
      auction_id: this.placeBidButton.data('auction-id'),
      lot_id: this.placeBidButton.data('lot-id')
    }

    $.ajax({
      url: this.unlockBiddingUrl,
      data,
      type: 'POST',
      timeout: 5000
    })
  }

  static placeBid () {
    this.disableForm()
    this.showSpinner()

    const data = {
      auction_id: this.placeBidButton.data('auction-id'),
      lot_id: this.placeBidButton.data('lot-id'),
      amount: this.placeBidButton.data('amount')
    }

    $.ajax({
      url: this.placeBidUrl,
      data,
      type: 'POST',
      timeout: 5000
    }).done(() => {
      this.hideError()
    }).fail((_xhr, _status, error) => {
      this.showError(error)
      if (error === 'Conflict') {
        this.enableForm()
      } else { this.disableForm() }
    }).always(() => {
      this.hideSpinner()
    })
  }

  static showSpinner () {
    if (!this.spinnerContainer) { return }
    this.spinnerContainer.show()
  }

  static hideSpinner () {
    if (!this.spinnerContainer) { return }
    this.spinnerContainer.hide()
  }

  static showError (error) {
    const errorContainer = this.el.find(`[data-bidding-error='${error}']`)
    if (!errorContainer) { return }

    errorContainer.show()
  }

  static hideError () {
    const errorContainer = this.el.find('[data-bidding-error]')
    if (!errorContainer) { return }

    errorContainer.hide()
  }

  static enableForm () {
    if (!this.placeBidButton) { return }
    this.placeBidButton.removeAttr('disabled')
  }

  static disableForm () {
    if (!this.placeBidButton) { return }
    this.placeBidButton.attr('disabled', true)
  }

  static isUnlockCookieSet (lotId) {
    return document.cookie.indexOf('unlock-bidding-lot-' + lotId) > -1
  }

  static setUnlockCookie (lotId) {
    const twentyMinutesFromNow = new Date()
    twentyMinutesFromNow.setTime(twentyMinutesFromNow.getTime() + (20 * 60 * 1000))
    const expires = '; expires=' + twentyMinutesFromNow.toGMTString()
    document.cookie = 'unlock-bidding-lot-' + lotId + '=' + '1' + expires + '; path=/'
  }

  static _onLivePage () {
    return $('.c-live-page-active').length > 0
  }
}
